import firebase from '@/mixins/firebase'
export default {
  mixins: [ firebase ],
  data () {
    return {
      _savePending: false,
      _saveTimeout: null,
      _saveActive: false,
      _saveFunction: null
    }
  },
  methods: {
    _autosave (savePath, value, timer = 500) {
      this._savePending = true

      if (this._saveTimeout) { clearTimeout(this._saveTimeout) }

      if (this._saveFunction) { this._saveFunction = null }

      this._saveFunction = () => {
        this._dbSave('rtdb', savePath, value)
          .then(() => {
            this._savePending = false
            setTimeout(() => {
              this._saveActive = false
            }, 500)
          })
      }

      this._saveTimeout = setTimeout(() => {
        this._saveActive = true
        this._saveFunction()
        this._saveFunction = null
        this._saveTimeout = null
      }, timer)
    }
  }
}
